import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { LoadingButton } from '@mui/lab';

import { resetStripe } from '../../../redux/legacy/reducers/ducks/legacy/StripeDuck';
import Notification from '../Notification';
import errorMessages from '../../../constants/errorMessages';
import { toggleGlobalLoaderQueue } from '../../../redux/legacy/reducers/ducks/legacy/MainDuck';
import { setCheckoutData } from '../../../redux/legacy/reducers/ducks/legacy/OrderDuck';

function StripeCheckoutComponent({ isPurchaseEnabled, onClick }) {
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);
  const [startCheckoutProcess, setStartCheckoutProcess] = useState(false);

  const { checkoutData, isCheckout, stripeResponse } = useSelector(
    ({ order, stripe }) => ({
      checkoutData: order.checkoutData,
      isCheckout: order.isCheckout,
      stripeResponse: stripe.stripeResponse,
    })
  );

  useEffect(() => {
    if (startCheckoutProcess && checkoutData && isCheckout) {
      setStartCheckoutProcess(false);
    }
  }, [checkoutData, isCheckout, startCheckoutProcess, dispatch]);

  useEffect(() => {
    if (stripeResponse?.response) {
      dispatch(setCheckoutData({ ...checkoutData, isEnded: true }));
      window.location.assign(stripeResponse?.response?.redirection_url);
      dispatch(resetStripe());
    } else if (stripeResponse?.error) {
      Notification.error(errorMessages.STRIPE_URL_IS_MISSING, {
        toastId: 'StripeUrlError',
      });
    }

    setIsLoading(false);
  }, [stripeResponse]);

  useEffect(() => {
    if (checkoutData?.isEnded) {
      dispatch(
        toggleGlobalLoaderQueue({
          name: 'checkoutEnd',
          status: false,
        })
      );
    }
  }, [checkoutData, dispatch]);

  return (
    <LoadingButton
      fullWidth
      size="large"
      onClick={onClick}
      variant="contained"
      loading={isLoading}
      id="place-order-button"
      disabled={!isPurchaseEnabled}
      data-test-id="place-order-button"
      sx={{ fontSize: 16, height: 64 }}
    >
      Go to Payment
    </LoadingButton>
  );
}

StripeCheckoutComponent.propTypes = {
  isPurchaseEnabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default StripeCheckoutComponent;
